import AppButton from "@/components/AppButton.vue";
export default {
  name: "ShowMustLogin",
  components: {
    AppButton
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    handleLogin() {
      this.loading = true;
      window.location.reload();
    }
  }
};